import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { translatedMessage } from '../../service/LanguageService';

import GeneralUtils from '../../utilities/GeneralUtils';
import DOMPurify from 'dompurify';

const JobViewDialog = (props) => {
    const [job, setJob] = useState(null);

    useEffect(() => {
        // console.log("JobViewDialog props: ", props?.value);
        setJob(props?.value);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        </>
    );

    return (
        <>
            <Dialog
                visible={props?.visible}
                header={translatedMessage('job.jobDetails')}
                modal
                className="pcn-dialog"
                footer={formDialogFooter}
                onHide={hideDialog}
            >
                <div className='w-full grid pcn-data-view-panel'>
                    <div className='col-12'>
                        <div className='filed-label'>{translatedMessage('competition.institution')}</div>
                        <div className='filed-value'>{job?.institution?.name}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.position')}</div>
                        <div className='filed-value'>{job?.position}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.positionClass')}</div>
                        <div className='filed-value'>{GeneralUtils.dashIfNullForObject(job?.jobClass)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.positionLevel')}</div>
                        <div className='filed-value'>{GeneralUtils.dashIfNullForObject(job?.level)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.departmentType')}</div>
                        <div className='filed-value'>{GeneralUtils.dashIfNullForObject(job?.departmentType)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.departmentName')}</div>
                        <div className='filed-value'>{GeneralUtils.dashIfNullForObject(job?.departmentName)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('job.jobID')}</div>
                        <div className='filed-value'>{GeneralUtils.dashIfNullForObject(job?.jobID)}</div>
                    </div>
                    {job?.workingHours &&
                        <div className='col-12 md:col-6'>
                            <div className='filed-label'>{translatedMessage('job.workingHours')}</div>
                            <div className='filed-value'>{job?.workingHours?.label}</div>
                        </div>
                    }
                    {job?.location &&
                        <div className='col-12 md:col-6'>
                            <div className='filed-label'>{translatedMessage('job.location')}</div>
                            <div className='filed-value'>{job?.location + " - " + job?.jobCounty?.label}</div>
                        </div>
                    }
                    {job?.jobDuty &&
                        <div className='col-12'>
                            <div className='filed-label'>{translatedMessage('job.jobDuty')}</div>
                            <div className='filed-value'>
                                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job?.jobDuty) }} />
                            </div>
                        </div>
                    }
                </div>
            </Dialog >
        </>
    );
};

export default JobViewDialog;
